import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    enrichment: `${APP_CONFIG.care_cluster}/ms-tariffs-content/catalog`,
  },
}
